<template>
  <div class="page-header-index-wide">
    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">

          <a-tab-pane loading="true" :tab="currentDepartName" key="1">
            <a-row>
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <line-chart-base title="业绩统计(万元)" :height="360"  :dataSource="departTrendData"></line-chart-base>
              </a-col>
              <!--对比上月 5 10 25 30等对比-->
              <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <line-chart-multid title="业绩对比" :height="360" :fields="comparisonFields" :dataSource="comparisonData"></line-chart-multid>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>

    <a-row>
      <a-col :span="24">
        <a-card :loading="loading" :bordered="false" title="财务统计" :style="{ marginTop: '24px' }">
          <a-row>
            <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
              <line-chart-base title="公司业绩(万元)" :height="360"  :dataSource="companyDataByFinance"></line-chart-base>
            </a-col>
            <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
              <line-chart-multid title="业绩对比" :height="360" :fields="financeComparisonFields" :dataSource="financeComparisonData"></line-chart-multid>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="24">
        <a-card :loading="loading" :bordered="false" title="部门统计" :style="{ marginTop: '24px' }">
          <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <line-chart-multid title="业绩对比" :height="360" :fields="multiDepartComparisonFields" :dataSource="multiDepartComparisonData"></line-chart-multid>
          </a-col>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import moment from 'moment'
  import ChartCard from '@/components/ChartCard'
  import ACol from "ant-design-vue/es/grid/Col"
  import ARow from 'ant-design-vue/es/grid/Row'
  import LineChartBase from '@/components/chart/LineChartBase'
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import { mapGetters } from 'vuex'
  import { getAction, postAction} from '@/api/manage'
  import {toDecimal, padRight} from '@/utils/util'

  export default {
    name: "IndexBdc",
    components: {
      ARow,
      ACol,
      ChartCard,
      LineChartBase,
      LineChartMultid,
    },
    data() {
      return {
        loading: true,
        currentDepartName:'', //享赢巴(万元)
        departTrendData:[], //当前部门逐月数据
        comparisonFields:[],
        comparisonData:[], //业绩对比数据
        companyDataByFinance:[],// 财务口统计的全公司数据
        financeComparisonFields:[],// 财务口对比上月数据字段
        financeComparisonData:[],// 财务口对比上月数据
        multiDepartComparisonFields:[],//各部门间对比字段
        multiDepartComparisonData:[],//各部门间对比数据
        url:{
          getBusinessDep:'/sys/sysDepart/getBusinessDep', // 获取业务部门
          trendByDepMonth:'/bms/homePage/trendByDepMonth',
          trendContrastByDep:'/bms/homePage/trendContrastByDep', //当前登录部门业绩环比
          trendByFinance:'/bms/homePage/trendByCaiwuMonth',
          trendComparisonByFinance:'/bms/homePage/trendContrastByCaiwu',
          brokerageByMonthDep: '/bms/homePage/brokerageByMonthDep', //各部门业绩环比
        },
        businessDep:{}, // 业务部门
      }
    },
    created() {
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
      //当前部门名称
      this.currentDepartName = this.userInfo().orgCodeTxt;
      this.initBusinessDep();
    },
    methods: {
      ...mapGetters(["userInfo"]),
      // 查询业务部门
      initBusinessDep(){
        getAction(this.url.getBusinessDep,{}).then((res)=>{
          if(res.success){
            this.businessDep = res.result;
            // 当前部门业绩环比
            this.getTrendByDepMonth();
            this.getComparisonDepData();
            // 财务部门统计
            this.getTrendDataByFinance();
            this.getComparisonDataByFinance();
            // 多部门业绩环比
            this.getMultiDepartComparisonData();
          }else{
            this.$message.warning("获取部门失败")
          }
        })
      },

      //部门业绩逐月环比
      getTrendByDepMonth(){
        let that = this;
        getAction(this.url.trendByDepMonth,{}).then((res)=>{
          if(res.success){
            that.setTrendDepData(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setTrendDepData(trendData) {
        for (let item of trendData) { // 返回的是数组
          this.departTrendData.push({
            item: item.part + '月',
            value: toDecimal(item.brokerage)
          })
        }
      },

      // 部门业绩对比上月 间隔5天
      getComparisonDepData(){
        let that = this;
        getAction(this.url.trendContrastByDep,{}).then((res)=>{
          if(res.success){
            that.setComparisonDepData(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setComparisonDepData(comparisonData){
        //设置折线图数据
        this.comparisonFields = []
        this.comparisonFields.push("本月")
        this.comparisonFields.push("上月")
        this.comparisonData = [];
        let thisMonthSum = 0, lastMonthSum = 0;
        let typeItem = 0;
        for(let i=0; i<6; i++){ //确定返回6个元素
          thisMonthSum += comparisonData.thisMonth[i].brokerage;
          lastMonthSum += comparisonData.lastMonth[i].brokerage;
          typeItem = (i+1) * 5 + '天';
          if(i == 5){
            typeItem = '月底'
          }
          this.comparisonData.push({
            "本月": toDecimal(thisMonthSum),
            "上月": toDecimal(lastMonthSum),
            type: typeItem
          })
        }
      },

      // 财务统计公司业绩逐月环比
      getTrendDataByFinance(){
        let that = this;
        getAction(this.url.trendByFinance,{}).then((res)=>{
          if(res.success){
            that.setTrendDataByFinance(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setTrendDataByFinance(trendData) {
        for (let item of trendData) { // 返回的是数组
          this.companyDataByFinance.push({
            item: item.part + '月',
            value: toDecimal(item.brokerage)
          })
        }
      },

      // 财务统计公司业绩对比上月 间隔5天
      getComparisonDataByFinance(){
        let that = this;
        getAction(this.url.trendComparisonByFinance,{}).then((res)=>{
          if(res.success){
            that.setComparisonDataByFinance(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setComparisonDataByFinance(comparisonData){
        //设置折线图数据
        this.financeComparisonFields = []
        this.financeComparisonFields.push("本月")
        this.financeComparisonFields.push("上月")
        this.financeComparisonData = [];
        let thisMonthSum = 0, lastMonthSum = 0;
        let typeItem = 0;
        for(let i=0; i<6; i++){ //确定返回6个元素
          thisMonthSum += comparisonData.thisMonth[i].brokerage;
          lastMonthSum += comparisonData.lastMonth[i].brokerage;
          typeItem = (i+1) * 5 + '天';
          if(i == 5){
            typeItem = '月底'
          }
          this.financeComparisonData.push({
            "本月": toDecimal(thisMonthSum),
            "上月": toDecimal(lastMonthSum),
            type: typeItem
          })
        }
      },

      // 各部门业绩环比
      getMultiDepartComparisonData(){
        let that = this;
        getAction(this.url.brokerageByMonthDep,{}).then(res=>{
          if(res.success){
            that.setComparisonData(res.result);
          }else {
            that.$message.warning("查询业绩趋势失败")
          }
        })
      },
      setComparisonData(comparisonData){
        //设置折线图数据
        this.multiDepartComparisonFields = [];
        this.multiDepartComparisonData = [];
        for (let i = 0; i < this.businessDep.length; i += 1) {
          this.multiDepartComparisonFields.push(this.businessDep[i].departNameAbbr)
        }
        let month = moment().month(); // 从0开始的序号
        for(let i=0; i<=month; i++) {
          let obj ={};
          for (let j= 0; j < this.businessDep.length; j++) {
            obj[this.multiDepartComparisonFields[j]] = this.getBrokerageByOrgCode(comparisonData, i, this.businessDep[j].orgCode)
          }
          obj['type'] =  (i+1) + "月";
          this.multiDepartComparisonData.push(obj);
        }
      },
      getBrokerageByOrgCode(data, month, orgCode){
        let value = 0
        if(data[month].brokerageByDeps.length === 0){
          return 0
        }

        for(let item of data[month].brokerageByDeps){
          if(item.dep == orgCode){
            return item.brokerage;
          }
        }
        return 0;
      },
    }
  }
</script>

<style lang="less" scoped>

</style>
